<template>
  <div id="app">
    <el-container>
      <el-header height="" style="padding: 0px;margin: auto;width: 1200px;">
        <el-row type="flex" justify="space-between" style="padding: 16px 0px;">
          <el-col :span="15" style="margin: auto;">
            <img @click="toHome" src="@/assets/images/logo.png" style="width: 143px;height: 50px;cursor: pointer;vertical-align: middle;">
            <span @click="toHome" style="cursor: pointer;display: inline-block;vertical-align: middle;font-size: 20px;font-weight: bold">&nbsp;&nbsp;竞价采购网</span>
          </el-col>

<!--          <el-col>&nbsp;</el-col>-->

          <el-col :span="9">
            <el-row style="padding-bottom: 2px;letter-spacing: 1px;line-height: 22px"><span><img style="width: 16px;vertical-align:middle;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACBUlEQVRIS7XVPWhTURjG8f9Li1CMWEntPQlOgquDiLgUcVF0EkLORQUFBTtJwaFYJwcVOoiQinVRxOKQpFIcRCyiLoKji+AgCCom149WsCpam1duoEnvR2KSi2c8nPv8znnv+RD+c5NIftHLIXoa2I0yh2sOJ5lDEyi9XIekZ1BsIFB0L/nM016RJlD0JhEdjwbJA6xzMDlQ8hZAN7UI2oo1b3pB1pSoqi0DVM/iZiaTAp+AoRYh81izPylwH4ivtXCTvDmZDChWjiNyKxKiepmvZoJRWU4GlD6moFYBUoGgvr4suc1+f08teNCK1UsIE6Gkq1jjH7yeWhCYWxxk+Ze/HQfXpCkqI7jOs16E6FVR9kZRvR4Ke8ef2g6OZD93i0QBVaHsPQH2hMIeg7MPKyvdIFHA//ru+y2s9L8A0sF7iQJ5M5Yc8BPKlQOo+GcjOAllDNcUGsjsh53U+l9hh5fi4PgVrI4sVs8hXIx+qOOklgp823AD4SjwBfQ8mOlwCdsD/v+Y9e6gxL0JP4GBEP4cai42+3a1vz3gj/LfCYYegY50VntZrE/IdR764/8N1JGFjfB7HtjVGcJ3rKnfCJ0BTeRezPaNM19jzbbugEa50lPAqfYrkWNYZ6Z7oLG7vEOIXgMyEUi4Qt6c6fwnt5rq7ep6BjiBkgPZDvoDlQu4TuCa+QsQLJUZcqcJewAAAABJRU5ErkJggg==" />&nbsp;<label style="display:inline-block;vertical-align:middle;color: #1c9fd6">{{CONFIG.servicePhone}}</label></span></el-row>
            <!--<el-row style="padding-bottom: 2px;letter-spacing: 1px;line-height: 22px"><span><img style="width: 16px;vertical-align:middle;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACUklEQVRIS82WP2gUQRjF31u1EhQMgnobO9G7FUREFESLCCliUmjULuJeFBUNGETQJmijhRJBJWCzewo22kQQFIs0ChILUSS7YBrN7SWCqQ40YnSfjF50c7lLVkjE6Xbnzft98803fwgAtheeAnUWwFrzPQ9tBOKVKJ+9yYr5jXkwnWkhdtH2g/fzGHk1ZMQAtCDRV0z/C0A/gZcCWgBsrwQ2CPAFoK2JfzUTUX8GxDcKB4purn+VN7xysTU5AGGjSL/0bsMRXGBsHDNeeJ7UpXpprgeIQR2KDjt3f5axHzwEsAfAg2hpth0H+T1paHtDF0H21ILUBEg6Xso7t6YG2H5goh2Lv35eNzq25cua1W9XjB5bP540bCwEvRK6qyEzAATPFN1sb1KY8YMPJBoUsweWWihshrQ7yjuDv3US7UJogjqaHFsN6I/c3N7qKDJ+0EHgTtX/MqTmaZB7WmR/Cl8DcKa00wAEThbdXF+tXNre0DYCOwEMxxaXU/ABlAHuitzsmz/pDK8D6qoJAOBFbq4zzcZr9IITIvpAjENsmoLYfvA8WbrVKYoJtJvSTAPJ+MFpAtcMROQOS2iTdHW2NTB9kxL3lfJZU5pzNtsPzwG6DOAjgAYA1lwA0z8hqbWUdwbmJJh9UgjvQ9qfeh9UhBNWrOaRTufZbJCMN9RE8jGAJX8LMPqZpZhwMZUF8gmAZfWCSHOalgm1Fl3naXJTZW6HHRTMRVXX3OjTAIzOHBWPJLyCBVFsA7QpzfqkBaTxqqn5B1fmrxfFwl36Zl4L+Wz5AYT0DSYodZBuAAAAAElFTkSuQmCC" />&nbsp;<label style="display:inline-block;vertical-align:middle;color: #1c9fd6">{{CONFIG.joinPhone}}</label></span></el-row>-->
            <el-row style="padding-bottom: 2px;letter-spacing: 1px;line-height: 22px"><span><img style="width: 16px;vertical-align:middle;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAbCAYAAABm409WAAADD0lEQVRIS7WWS2hUZxTHf+fexGSRgBVjnDxIKlaG8YFEkbiwNIFaoUgX6iSoBKe+FrqoUiQoSPDRhSnYRaGg0IgPyCSC7cZWBS0uVGhdRHRiYxRNrpnE+qpoNJmZe+RGOw0z905uFn7Le8/3/53znf893xU+8BJf+u0DNZjGDlQ+Ay0BhhDOofoD4UAsl8bEgM7Bb1C+B0wXoQTIdsKlR7wguQGdQ+tQPTlBlTaqK2kInHWL8wZ0PCoC+y4ww8cx3qWkNEidJDNjvQHReBiRqA/xdyGq9TQELvkHdMZbUfnWNwDdRTjQOgnA0I+obvMNEN3PmsBe/4Do4G6Eg74ByFY3N3n3wPG+YVz3CbAx7VmsKnvgvwInsiP+O8gXE0KUUzTMXD85m44BHpdD8ipQ6Q3RHhKjtayrejZ5QIsazH9YRso8CrLCReAMSXsLPYGntIg9KUB52601BtKMbazs3xgcYKwn5rtZpMRR+wKNZd1VJ2KBVFJ+U00dePj1vNO+elD+883VIkb7+/kzqLBr5uhw+/WtixNpgQ41K4ZjjagcAsqAlKrdmAnJclF1W3d1Er0BFGdk80TQK+pkb4gjWIsyPSNmWCS1oH/DfGfEjK0sQMWx2FGUTW7n+XllMYeXBdhzbZBf773w6vsJKxJq8ga0xe4DVZm7pxaY/Bn+hEJTSNjKko5eHr/Jmm3Otj4rEkrvd6sggZLnlt6OhdPZubCEn24+4bu/HnlVkLAioSm5KlC3nQWmcKSugvqKIi4PvGLzRYvhpKszR6xIqDAX4DWQDvgvMPhRARe+mpVmLz3di/Xyf1ONS+pfKxKamgPQPQSadclUFuVzZfXstE5N9A7/vHbtQdyKhByXebmouxXVrHtgWqFJV+OcNCB46m9eJbKOaFSEff0bQukp7DpNK4/FPlWbZgRn0BmOar4h3GsKjgGStvLx8dvjW2WDniGlzdameb3jX+S89EuPd83IT+YtR8T5qGp++bJ60RRT8p+PpHTt+b440AX8YZsaHWia2+dmjol/W7zM6PP5Bwe8Be/nEiu3Mds4AAAAAElFTkSuQmCC" />&nbsp;<label style="display:inline-block;vertical-align:middle;color: #1c9fd6">{{CONFIG.serviceQQ}}<a :href="CONFIG.qqHref" target="_blank" :title="CONFIG.qqTip" style="color: #1c9fd6">{{CONFIG.QQ}}</a></label></span></el-row>
          </el-col>
        </el-row>
      </el-header>

      <el-main style="overflow: hidden;min-height: 470px;padding: 0px;">
        <router-view/>
      </el-main>

      <el-footer style="padding: 0px;margin: auto;width: 1200px;">
        <el-row style="color: #999; font-size: 14px;">
          <el-row type="flex" justify="center" align="middle" style="margin: 16px 0px;text-align: center;">
            <el-col :span="6"></el-col>
            <el-col :span="6"><label>客服热线:020-80922370/80922307</label></el-col>
            <!--<el-col :span="4"><label>{{CONFIG.joinPhone}}</label></el-col>-->
            <el-col :span="4"><label>{{CONFIG.serviceQQ}}<a :href="CONFIG.qqHref" target="_blank" :title="CONFIG.qqTip">{{CONFIG.QQ}}</a></label></el-col>
            <el-col :span="6"></el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle" style="margin: 16px 0px;text-align: center;">
            <el-col :span="6"><label>竞价网&nbsp;<a :href="JJW_URL" target="_blank">{{JJW_URL.replace("https://",'')}}</a></label></el-col>
            <!--<el-col :span="4"><label><a :href="HOME_PAGE_URL" target="_blank">广州高采信息技术有限公司</a></label></el-col>-->
            <!--<label>|</label>&nbsp;&nbsp;-->
            <el-col :span="5">
              <label><a :href="HOME_JCX_URL" target="_blank">广州竞采星信息技术有限公司</a></label>
             </el-col>
<!--            <el-col :span="6"> <label>竞采星&nbsp;<a :href="HOME_JCX_URL" target="_blank">{{HOME_JCX_URL.replace("http://",'')}}</a></label></el-col>-->
            <el-col :span="6">
              <label style="cursor: pointer" @click="getPrivacy">
                隐私政策
              </label>
            </el-col>
          </el-row>
        </el-row>
      </el-footer>
      <!--隐私政策-->
      <el-dialog
        width="70%"
        :visible.sync="dialogVisibleNei"
      >
        <div class="custom_scrollbar" style="border: none;height: 450px;width: 100%;resize: none;line-height: 24px;color: #666;outline: none;overflow: scroll" v-if="privacy">
          <div v-html="privacy"/>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
  import registerApi from '@/api/supplier/register'
  export default {
    name: 'App',
    data(){
      return {
        privacy:null,
        dialogVisibleNei:false
      }
    },
    methods: {
      /* 跳转至首页 */
      toHome () {
        window.location.href = this.HOME_PAGE_URL
      },
      getPrivacy(){
        this.dialogVisibleNei = !this.dialogVisibleNei
        registerApi.privacy().then(data => {
          this.privacy = data.paramValue
        })
      }

    }
  }
</script>

<style>
  body {
    margin: 0;
    padding: 0
  }

  a {
    color: #999;
    text-decoration:none;
  }

  a:hover {
    text-decoration: underline;
  }

  .router-link-active {
    text-decoration: none;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-width: 1200px;
    margin: 0px auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue